import { ReloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { MdmTable } from "src/components/MdmTable";
import { PageLayout } from "src/components/PageLayout";
import { RtColumnsSettingsButton } from "src/components/ReactiveTable/components/RtColumnsSettings";
import { ToolBox2 } from "src/components/ToolBox2";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { classifiersPageStore as pageStore } from "./ClassifiersPageStore";

export const ClassifiersPage: React.FC = observer(() => {
  const { tableStore, columns } = pageStore;

  const tools = (
    <>
      {/* Имхо это полезная фича, но потребовали убрать в MDM2-540.
          <Link to={makeUrl(PageUrl.managementClassifiers)}>
            <Button icon={<SettingOutlined />}>Управление</Button>
          </Link> */}
      <RtColumnsSettingsButton store={tableStore} />
      <Button
        icon={<ReloadOutlined />}
        onClick={() => tableStore.reload()}
        title="Обновить данные"
      />
    </>
  );

  return (
    <PageLayout title="Классификаторы">
      <ToolBox2 extraTools={tools} paddingMode="page">
        <MdmTable
          store={tableStore}
          columns={columns}
          resizableColumns
          rowClick={{
            type: "link",
            builder: (row) => makeUrl(PageUrl.classes, { id: row.id }),
          }}
        />
      </ToolBox2>
    </PageLayout>
  );
});
